import React, { useEffect, useState } from "react";
import { equals, has, length, lensPath, view } from "ramda";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";

import ContentFacetAutocomplete from "./ContentFacetAutocomplete";
import ContentFacetPublicationYearSlider from "./ContentFacetPublicationYearSlider";
import ContentFacetMediaStatus from "./ContentFacetMediaStatus";

import Collapse from "@material-ui/core/Collapse";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import Grid from "@material-ui/core/Grid";
import ListItemText from "@material-ui/core/ListItemText";
import MenuItem from "@material-ui/core/MenuItem";

const useStyles = makeStyles(theme => ({
  checkboxes: {
    height: "auto",
    maxHeight: "200px",
    overflowY: "auto",
    backgroundColor: theme.palette.primary.light,
  },

  expanded: {
    backgroundColor: theme.palette.primary.light,
    "&:hover": {
      backgroundColor: theme.palette.primary.light,
    },
  },

  facet: {
    backgroundColor: "transparent",
    "&:hover": {
      backgroundColor: "transparent",
      color: "black",
    },
  },

  menu: {
    borderRadius: "5px",
    boxShadow: "0px 0px 30px rgba(149, 169, 177, 0.3)",
    width: "250px",
  },

  selectedFilters: {
    height: 22,
    width: 22,
    borderRadius: "20px",
    backgroundColor: theme.palette.primary.brandPrimary,
    color: "white",
    fontWeight: "bold",
    marginLeft: theme.spacing(1),
  },

  widget: {
    height: "auto",
    backgroundColor: theme.palette.primary.light,
  },
}));

const ContentFacetMenuItem = props => {
  const {
    useCustomStatusFacet,
    facet,
    index,
    selectedMenuItem,
    selectedFacets,
    handleFacetSelection,
    handleClick,
    handleStatusClick,
  } = props;

  const classes = useStyles();

  //-- Handle date range for Publication Years
  const [dates, setDates] = useState([]);
  useEffect(() => {
    if (has("contentDatePublished", selectedFacets)) {
      const { start, end } = view(
        lensPath(["contentDatePublished", "terms"]),
        selectedFacets,
      )[0];
      setDates([start, end]);
    } else {
      setDates([1, new Date().getFullYear()]);
    }
  }, [selectedFacets]);

  return (
    <div>
      <MenuItem
        button
        onClick={() => handleClick(facet.name)}
        classes={{
          root: clsx(classes.facet, {
            [classes.expanded]: equals(selectedMenuItem, index),
          }),
        }}
        tabIndex={0}
      >
        <ListItemText
          primary={
            <Grid container>
              <Grid item id={`facet-${facet.displayName}`}>
                {facet.displayName}
              </Grid>
              {length(facet.selectedTerms) > 0 && (
                <Grid
                  item
                  container
                  justify="center"
                  alignItems="center"
                  className={classes.selectedFilters}
                >
                  <Grid item>{length(facet.selectedTerms)}</Grid>
                </Grid>
              )}
            </Grid>
          }
          classes={{ primary: classes.facet }}
        />
        {equals(selectedMenuItem, facet.name) ? <ExpandLess /> : <ExpandMore />}
      </MenuItem>
      <Collapse in={equals(selectedMenuItem, facet.name)} timeout="auto">
        <div className={classes.widget}>
          {facet.name === "contentDatePublished" ? (
            <ContentFacetPublicationYearSlider
              dates={dates}
              handleDateRangeSelected={handleFacetSelection}
              facet={facet}
            />
          ) : facet.name === "status" && useCustomStatusFacet ? (
            <ContentFacetMediaStatus
              handleClick={handleStatusClick}
              facet={facet}
            />
          ) : (
            <ContentFacetAutocomplete
              facet={facet}
              handleFacetsSelected={handleFacetSelection}
              selectedTerms={facet.selectedTerms}
            />
          )}
        </div>
      </Collapse>
    </div>
  );
};

export default ContentFacetMenuItem;
